// Labels are keys of the `marketing` UI dictionary.
export const MARKETING_NAV = [
  { href: "/features", label: "nav.features" },
  { href: "/how-it-works", label: "nav.howItWorks" },
  { href: "/examples", label: "nav.examples" },
  { href: "/themes", label: "nav.themes" },
  { href: "/pricing", label: "nav.pricing" },
  { href: "/help", label: "nav.help" },
] as const;

export const FOOTER_COLUMNS = [
  { title: "footer.columns.product", links: [
    { href: "/features", label: "nav.features" },
    { href: "/how-it-works", label: "nav.howItWorks" },
    { href: "/themes", label: "nav.themes" },
    { href: "/examples", label: "nav.examples" },
    { href: "/pricing", label: "nav.pricing" },
  ] },
  { title: "footer.columns.resources", links: [
    { href: "/help", label: "footer.links.helpCenter" },
    { href: "/faq", label: "footer.links.faq" },
    { href: "/help#domains", label: "footer.links.customDomains" },
    { href: "/help#affiliate", label: "footer.links.affiliateDisclosures" },
    { href: "/contact", label: "footer.links.contact" },
  ] },
  { title: "footer.columns.legal", links: [
    { href: "/terms", label: "footer.links.terms" },
    { href: "/privacy", label: "footer.links.privacy" },
    { href: "/cookies", label: "footer.links.cookies" },
  ] },
] as const;
